module.exports = __webpack_public_path__ + "img/Full Car.f7f654b8.png";